module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bg-lgrey",
    class: {
      editing: _vm.currentIndex !== null
    },
    attrs: {
      "id": "k1uprights"
    }
  }, [_c('tooltips', {
    attrs: {
      "tippy": _vm.tooltipsData,
      "box": _vm.tooltipsBox
    }
  }, [_c('room', {
    staticStyle: {
      "pointer-events": "none"
    }
  }, [(_vm.tooltipsUpright) ? _c('k1wallupright', {
    attrs: {
      "data": _vm.tooltipsUpright,
      "show-edit": true,
      "width": _vm.widths[_vm.tooltipsUpright.width],
      "height": _vm.heights[_vm.tooltipsUpright.height],
      "is-disabled": false,
      "show-add": true
    }
  }) : _vm._e()], 1)], 1), _vm._v(" "), _c('room', _vm._l((_vm.uprights), function(upright, index) {
    return _c('k1wallupright', {
      key: ("upright-" + index),
      attrs: {
        "data": upright,
        "show-edit": _vm.currentIndex !== index,
        "width": _vm.widths[upright.width],
        "height": _vm.heights[upright.height],
        "is-disabled": _vm.currentIndex !== index && _vm.currentIndex !== null,
        "show-add": !_vm.room_is_full && index === _vm.uprights.length - 1
      },
      on: {
        "edit": function($event) {
          _vm.editUpright(index)
        },
        "add": function($event) {
          _vm.addUpright()
        }
      }
    }, _vm._l((_vm.objects()[index]), function(object, obj_index) {
      return _c('k1element', {
        key: ("obj-" + index + "-" + obj_index),
        attrs: {
          "is-disabled": true,
          "pos-slot": object.slot,
          "img": _vm.objectRightWidth(object, index).frontal_inactive
        }
      })
    }))
  })), _vm._v(" "), _c('editbar', {
    attrs: {
      "buttons": _vm.editButtons,
      "is-visible": _vm.editBarIsVisible,
      "show-delete": _vm.uprights.length > 1
    },
    on: {
      "delete": function($event) {
        _vm.removeConfirmUpright(_vm.currentIndex)
      },
      "confirm": _vm.hideEditBar
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6f50e8e4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./app/components/uprights/K1_wall.vue
// module id = 643
// module chunks = 0